<template>
    <div>
        <public-title>{{(eateryId>0 ? '编辑':'添加')+'用餐'}}
            <span class="text-link ml-auto h6" slot="right" @click="$router.back()">返回列表</span>
        </public-title>
        <div class="bg-white p-5">
            <div class="d-center-start mb-5">
                <left-text leftText="用餐类型"/>
                <div class="d-center-start">
                    <span v-for="(v,ind) in $GVAR.BMealType" :key="ind" 
                        :class="{btnactive: current == ind}" @click="addClass(v,ind)">
                        {{ v.name }}
                    </span>
                </div>
            </div>
            <left-text-border class="mb-4" leftText="名称" v-model="eateryInfo.name" size="small" />
            <div class="d-center-start mb-3 w-100">
                <left-text leftText="排序"/>
                <el-input-number size="small" v-model="eateryInfo.sort" :min="1" />
                <label class="text-danger h6 ml-3">(数值越大，排名越靠前)</label>
            </div>
            <div class="d-center-start mb-4">
                <left-text leftText="价格"/>
                <div class="d-center-start w-100">
                    <el-radio-group v-model="eateryInfo.price_type" class="w-30 text-left">
                        <el-radio class="mb-0" :label="item.id" :key="item.name" v-for="item in $GVAR.EateryType">
                            {{item.name}}
                        </el-radio>
                    </el-radio-group>
                    <div class="w-60 text-left d-center-start">
                        <el-input placeholder="请输入内容" class="w-40" v-model="eateryInfo.price" size="small">
                            <template slot="append">元/{{eateryInfo.price_type | formatVar('EateryType')}}</template>
                        </el-input>
                        <left-text-border class="w-40 ml-5" v-if="eateryInfo.price_type == 2" leftText="人数不少于" v-model.number="eateryInfo.num" appendText="人" />
                    </div>
                </div>
            </div>
            <left-text-border type="textarea" class="mb-4" leftText="费用说明" v-model="eateryInfo.remarks" size="small" />
            <div class="d-center-start mb-4">
                <left-text leftText="相册"/>
                <upload-image @fileChange="(imgs)=>{this.eateryInfo.pic = imgs;}" class="ml-2"
                    :existImgs="eateryInfo.pic.length>0 ? eateryInfo.pic.split(',') : []" :maxLength="5" editMode />
            </div>
            <el-button class="mt-5" type="primary" @click="submitForm">提交</el-button>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions, mapState } from 'vuex'
import { UploadImages } from '@/assets/utils/uploadFiles'
export default {
    name: 'addEditEatery',
    data () {
        return {
            current: 0,
            eateryInfo: {
                price_type: '1',
                pic:[]
            }
        }
    },
    computed:   {
        ...mapState(['discountDetail']),
        ...mapGetters(['storeInfo','brand']),
        eateryId () { return this.$route.query.id },
    },
    mounted(){
        if(this.eateryId) {
            let data = {restaurant_id:this.eateryId}
            this.getStoreEateryLists({ data, successFun: (res) => {
               this.eateryInfo = res.info
               this.eateryInfo.price_type = String(res.info.price_type)
               if (res.info.tag_id == 99) this.current = this.$GVAR.BMealType.length - 1
               else this.current = res.info.tag_id - 1
            }})
        } else this.eateryInfo.tag_id = this.$GVAR.BMealType[0].id
    },
    methods: {
        ...mapMutations(['UPDATECURRENTSTORE']),
        ...mapActions(['addEditEatery','getStoreEateryLists']),
        addClass(v,ind){
            this.eateryInfo.tag_id = v.id;
            this.current = ind
        },
        validateForm() {
            if (!this.eateryInfo.name) return {code:false,msg:'请填写用餐名称'}
            if (!this.$GFUN.isFloatInteger(this.eateryInfo.price)) return {code:false,msg:'请填写用餐价格'}
            if(this.eateryInfo.price_type == 2 && !this.$GFUN.isPositiveInteger(this.eateryInfo.num)) return {code:false,msg:'请填写最少人数'}
            if(!this.eateryInfo.remarks) return {code:false,msg:'请填写费用说明'}
            if (this.eateryInfo.pic.length <= 0) return {code:false,msg:'请上传活动图片'}

            return {code:true,msg:'验证成功'}
        },
        submitForm () {
            let res = this.validateForm();
            if (res.code) {
            this._confirm('确认提交么？',async () => {
                this.eateryInfo.pic = await UploadImages(this.eateryInfo.pic);
                let pic = this.eateryInfo.pic.join(',');
                this.addEditEatery({
                    type: this.eateryId ? 'edit' : 'add',
                    data:{
                        ...this.eateryInfo,
                        pic,
                        restaurant_id:this.eateryId
                    }
                })
            })
            } else this._alert(res.msg,null,'error');
        }, 
    }
}
</script>

<style lang="scss" scoped>
.d-center-start{
    span{
        width: 60px;
        height: 22px;
        line-height: 22px;
        border: 1px solid #eee;
        border-radius: 5px;
        margin-right: 12px;
        cursor: pointer;
        font-size: 13px
    }
}
.btnactive{
    border: 1px solid #12B2CB!important;
    color: var(--smtc-color-primary);  
}
</style>